import React from 'react';

import { MdaContactDto } from 'components/intermediaryApplications/intermediaryApplications.dto';

import styles from './FeaturesRestricted.module.scss';

interface FeaturesRestrictedProps {
  mdaContacts: MdaContactDto[];
}

const FeaturesRestrictedText = ({ mdaContacts = [] }: FeaturesRestrictedProps) => {
  return (
    <>
      <p>
        Please contact one (1) of the below authorized individuals within your organization to complete the Contractor
        Registration and Master Dealer Agreement. Until then, features in this system are restricted.
      </p>
      <ul className={styles.ownersList}>
        {mdaContacts.map((owner) => (
          <li key={`${owner.firstName} ${owner.lastName}`}>
            {owner.firstName} {owner.lastName}
          </li>
        ))}
      </ul>
    </>
  );
};

export default FeaturesRestrictedText;
